import { render, staticRenderFns } from "./Companyinformation.vue?vue&type=template&id=f056c4f4&scoped=true"
import script from "./Companyinformation.vue?vue&type=script&lang=js"
export * from "./Companyinformation.vue?vue&type=script&lang=js"
import style0 from "./Companyinformation.vue?vue&type=style&index=0&id=f056c4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f056c4f4",
  null
  
)

export default component.exports